(() => {
  if (window.AlawooderHelp) {
    window.AlawooderHelp.mount(document);
    return;
  }
  const instances = new Map();
  const selector = '[data-help-section]';
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9\u00c0-\uffff]+/g, ' ').trim();

  function mount(section) {
    if (instances.has(section)) return;
    const search = section.querySelector('[data-help-search]');
    const tools = section.querySelector('[data-help-tools]');
    const clear = section.querySelector('[data-help-clear]');
    const count = section.querySelector('[data-help-count]');
    const empty = section.querySelector('[data-help-empty]');
    const reset = section.querySelector('[data-help-reset]');
    const topics = Array.from(section.querySelectorAll('[data-help-topic]'));
    const groups = Array.from(section.querySelectorAll('[data-help-group]'));
    const questions = Array.from(section.querySelectorAll('[data-help-question]')).map(element => ({
      element,
      category: element.dataset.helpCategory,
      text: normalize(`${element.querySelector('[data-help-question-text]')?.textContent || ''} ${element.querySelector('[data-help-answer]')?.textContent || ''}`)
    }));
    if (!search || !tools || !clear || !count || !empty || !reset) return;
    let category = 'all';
    const cleanups = [];
    const listen = (element, type, listener) => {
      element.addEventListener(type, listener);
      cleanups.push(() => element.removeEventListener(type, listener));
    };

    function render() {
      const terms = normalize(search.value).split(/\s+/).filter(Boolean);
      let matches = 0;
      const visibleCategories = new Set();
      questions.forEach(question => {
        const visible = (category === 'all' || question.category === category) && terms.every(term => question.text.includes(term));
        question.element.hidden = !visible;
        if (visible) { matches += 1; visibleCategories.add(question.category); }
      });
      groups.forEach(group => { group.hidden = !visibleCategories.has(group.dataset.helpGroup); });
      topics.forEach(topic => {
        const active = topic.dataset.helpTopic === category;
        topic.classList.toggle('is-active', active);
        topic.setAttribute('aria-pressed', String(active));
      });
      const resultLabel = matches === 1 ? (section.dataset.helpAnswerLabel || 'answer') : (section.dataset.helpAnswersLabel || 'answers');
      count.textContent = `${matches} ${resultLabel}`;
      clear.hidden = search.value.length === 0;
      empty.hidden = matches !== 0;
    }

    listen(search, 'input', render);
    listen(search, 'search', render);
    listen(clear, 'click', () => { search.value = ''; render(); search.focus(); });
    listen(reset, 'click', () => { search.value = ''; category = 'all'; render(); search.focus({ preventScroll: true }); tools.scrollIntoView({ block: 'start', behavior: 'instant' }); });
    topics.forEach(topic => listen(topic, 'click', () => {
      category = topic.dataset.helpTopic;
      render();
      const track = topic.closest('.ah-help-topics');
      if (track && track.scrollWidth > track.clientWidth) {
        const left = topic.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - 3;
        track.scrollTo({ left: Math.max(0, left), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }));
    tools.hidden = false;
    render();
    instances.set(section, {
      cleanup: () => cleanups.forEach(cleanup => cleanup()),
      selectBlock: blockId => {
        const question = questions.find(item => item.element.dataset.helpBlockId === blockId);
        if (!question) return;
        category = question.category;
        search.value = '';
        render();
        question.element.open = true;
        question.element.querySelector('summary')?.focus({ preventScroll: true });
        question.element.scrollIntoView({ block: 'center', behavior: 'instant' });
      }
    });
  }

  function within(root) {
    const sections = [];
    if (root.matches?.(selector)) sections.push(root);
    root.querySelectorAll?.(selector).forEach(section => sections.push(section));
    return sections;
  }
  const mountWithin = root => within(root).forEach(mount);
  window.AlawooderHelp = { mount: mountWithin };
  mountWithin(document);
  document.addEventListener('shopify:section:load', event => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', event => within(event.target).forEach(section => { instances.get(section)?.cleanup(); instances.delete(section); }));
  document.addEventListener('shopify:block:select', event => {
    const selected = event.target.closest?.(selector) || within(event.target)[0];
    if (selected) instances.get(selected)?.selectBlock(event.detail.blockId);
  });
})();
